import { EditContext, EditProvider } from "../contexts/edit-context";
import useContextWrapper from "./useContextWrapper";


export const useEditContext = () =>
  useContextWrapper(EditContext, {
    contextName: useEditContext.name,
    providerName: EditProvider.name
  });